import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

export const getMessageBrokerMultiaddrThunk = createAppAsyncThunk(
  'organization/getMessageBrokerMultiaddr',
  async(organizationId: string, { extra: { organizationService } }) =>
    await organizationService.getMessageBrokerMultiaddr(organizationId)
);
